export const selectorsContent = `
Selectors provide a powerful way to analyze your project’s dependencies using our custom query language.  
For more information, see the [Selectors documentation](https://docs.vlt.sh/cli/selectors)
`
